import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { Section, Heading } from "../components/Bits";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const nextParam = new URLSearchParams(location.search).get("next");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account erstellt – willkommen!");
      navigate(nextParam || "/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registrierung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Section>
      <div className="max-w-md mx-auto plant-card p-8" data-testid="register-card">
        <img
          src="https://customer-assets.emergentagent.com/job_adventure-plants-lu/artifacts/iirha844_IMG_5450.png"
          alt="AdventureCouple.lu"
          className="h-20 w-auto mx-auto mb-4"
        />
        <Heading overline="Account" title="Registrieren" />
        <form onSubmit={submit} className="space-y-4">
          <input required placeholder="Dein Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-4 py-3 rounded-xl border" style={{ borderColor: "var(--wp-border)" }} data-testid="register-name" />
          <input required type="email" placeholder="E-Mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 rounded-xl border" style={{ borderColor: "var(--wp-border)" }} data-testid="register-email" />
          <input required type="password" minLength={6} placeholder="Passwort (min. 6 Zeichen)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full px-4 py-3 rounded-xl border" style={{ borderColor: "var(--wp-border)" }} data-testid="register-password" />
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="register-submit">{loading ? "Lege an…" : "Account erstellen"}</button>
        </form>
        <div className="text-sm text-center mt-6 opacity-70">
          Schon Account? <Link to="/login" className="text-[var(--wp-primary)] font-medium">Anmelden</Link>
        </div>
      </div>
    </Section>
  );
}
